import lineChart from './lineChart';

const fillRateChart = {
  options: {
    ...lineChart.options,
    yaxis: {
      labels: {
        style: {
          fontSize: '14px',
          fontWeight: 600,
          colors: ['#8c8c8c'],
        },
        formatter: (value) => {
          return `${value * 100}%`;
        },
      },
    },
    tooltip: {
      x: {
        format: 'yyyy-MM-dd HH:mm',
      },
      y: {
        formatter: function (val) {
          return `${Math.round(val * 10000) / 100}%`;
        },
      },
    },
  },
};

export default fillRateChart;
